import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "avatar-photo",
  templateUrl: "./avatar-photo.component.html",
})
export class AvatarPhotoComponent implements OnInit {
  @Input()
  public photoUrl: string;

  @Input()
  public name: string;

  public showInitials = false;
  public initials: string;
  public circleColor: string;

  private colors = [
    "#EB7181", // red
    "#468547", // green
    "#FFD558", // yellow
    "#3670B2", // blue
  ];

  ngOnInit() {
    if (!this.photoUrl) {
      this.showInitials = true;
      this.createInitials();

      const randomIndex = Math.floor(
        Math.random() * Math.floor(this.colors.length)
      );
      this.circleColor = this.colors[randomIndex];
    }
  }

  private createInitials(): void {
    let initials = "";

    if (this.name.length > 2) {
      this.initials =
        this.name.charAt(0).toUpperCase() + this.name.charAt(1).toUpperCase();
    } else {
      this.initials = "NA";
    }

    // for (let i = 0; i < this.name.length; i++) {
    //   if (this.name.charAt(i) === ' ') {
    //     continue;
    //   }
    //
    //   //if (this.name.charAt(i) === this.name.charAt(i).toUpperCase()) {
    //   initials += this.name.charAt(i).toUpperCase();
    //
    //   if (initials.length == 2) {
    //     break;
    //   }
    //   //}
    // }

    // this.initials = initials;
  }
}



// WEBPACK FOOTER //
// ./src/components/avatar-photo/avatar-photo.component.ts